<template>
<div class="options_title_lyout">
    <div class="options_title_lyout_title">
        {{title}}
    </div>
    <div class="defalut_boder_bottom_line"></div>
</div>
</template>

<script>
    export default {
        components: {
        },
        props:{
            title:{
                type:String,
                default:"",
            },
        },
        computed: {
        },
        data() {
            return {
            };
        },
        watch:{
           
        },
        created(){
        },
        methods: {
        }
    }
</script>

<style lang="less" scoped>
@import url("./custom-options-title.less");
</style>
